import {
  queryBanners,
  querySecondNavs
} from '@/axios/com'

import {
  queryHouseAttrs,
  queryHouseList,
  queryHouseDetail,
  queryComments
} from '@/axios/house'
import { regionData } from 'element-china-area-data'
const houseAttrMap = {
  '类型': 'type',
  '单价': 'price',
  '特色': 'characteristic',
  '面积': 'measure',
  '售价': 'price',
  '居室': 'room',
  '其他': 'other',
  '朝向': 'direction',
  '房屋类型': 'housetype',
  '楼层': 'floor',
  '建造年代': 'year',
  '装修': 'step',
  '租金': 'price',
  '房型': 'layout'
}

function getRegionAreas (region) {
  return regionData.find(item => item.value === region[0]).children.find(item => item.value === region[1]).children
}

const houseData = {
  state: {
    curRegion: localStorage.getItem('cur-region') ? localStorage.getItem('cur-region').split('-') : ['320000', '320900'],
    curRegionAreas: localStorage.getItem('cur-region') ? getRegionAreas(localStorage.getItem('cur-region').split('-')) : getRegionAreas(['320000', '320900']),
    houseBanners: [],
    houseNavs: [],
    houseAttrs: [],
    houseList: [],
    houseTotal: 0,
    detail: {},
    commentList: [],
    commentTotal: 0
  },
  mutations: {
    SET_CUR_REGION (state, data) {
      state.curRegion = data.curRegion
      state.curRegionAreas = getRegionAreas(data.curRegion)
    },
    SET_HOUSEBANNERS (state, data) {
      state.houseBanners = data
    },
    SET_HOUSENAVS (state, data) {
      state.houseNavs = data
    },
    SET_ATTRS (state, data) {
      state.houseAttrs = data
    },
    SET_LIST (state, data) {
      state.houseList = data.data.map(item => ({
        id: item.id,
        name: item.title,
        area: item.area ? item.area.area : item.city.area,
        position: item.address,
        price: item.reference_unit_price,
        wuye: item.property_type,
        kaifashang: item.developers,
        shoufu: item.minimum_down_payment,
        kaipan: item.open_date,
        jiaofang: item.delivery_date,
        thumb: item.pictures ? item.pictures[0].path : ''
      }))
      state.houseTotal = data.total
    },
    SET_DETAIL (state, data) {
      state.detail = data
    },
    setCommentList (state, data) {
      state.commentList = data.data
      state.commentTotal = data.total
    }
  },
  actions: {
    CUR_REGION ({ commit }, params) {
      localStorage.setItem('cur-region', params.curRegion.join('-'))
      commit('SET_CUR_REGION', {
        curRegion: params.curRegion
      })
    },
    async HOUSEBANNERS ({ commit }, params) {
      const res = await queryBanners(params)
      commit('SET_HOUSEBANNERS', res.data.data.fbanner)
    },
    async HOUSENAVS ({ commit }, params) {
      const res = await querySecondNavs(params)
      commit('SET_HOUSENAVS', res.data.data)
    },
    async HOUSEATTRS ({ commit }, params) {
      /**
       * 对属性进行格式转换
       */
      const format = (attrs) => {
        let attrArr = []
        const getItems = (obj) => {
          let result = []
          for (let k in obj) {
            result.push({
              title: obj[k].value,
              value: k
            })
          }
          return result
        }
        for (let key in attrs) {
          attrArr.push({
            title: key,
            filterKey: houseAttrMap[key],
            items: getItems(attrs[key])
          })
        }
        return attrArr
      }
      const res = await queryHouseAttrs(params)
      commit('SET_ATTRS', format(res.data.data))
    },
    async HOUSELIST ({ commit }, params) {
      const res = await queryHouseList(params)
      if (res.data.code === 200) {
        commit('SET_LIST', res.data.data)
      } else {
        commit('SET_LIST', {
          data: [],
          total: 0
        })
      }
    },
    async HOUSE_DETAIL ({ commit }, params) {
      const res = await queryHouseDetail(params)
      commit('SET_DETAIL', res.data.data)
    },
    async HOUSE_COMMENTS ({commit}, params) {
      const res = await queryComments(params)
      commit('setCommentList', res.data.data)
    }
  }
}

export default houseData



// WEBPACK FOOTER //
// ./src/store/modules/houseData.js